/** @format */

import { Navigate, Outlet } from "react-router-dom";
import appConfig from "../configs/app.config";
import { useAppSelector } from "../store/hook";
import * as RoleSelector from "src/store/role/selector";

const { authenticatedAdminEntryPath, authenticatedUserEntryPath } = appConfig;

const PublicRoute = () => {
  const role = useAppSelector(RoleSelector.selectUserRole);

  if (role != "employer") {
    return <Navigate to={authenticatedAdminEntryPath} />;
  } else if (role != "user") {
    return <Navigate to={authenticatedUserEntryPath} />;
  }

  return <Outlet />;
};

export default PublicRoute;
